
import React, {useEffect, useState} from 'react';
import {arrayOf, func, shape, string} from 'prop-types';
import {Toggle, ToggleGroup} from '@sabre/spark-react-core';
import {map} from 'lodash';

const ToggleTabs = ({configToggle}) => {
    const [toggleCheckedValue, setToggleCheckedValue] = useState(configToggle.selectedValue);

    const handleToggleOnClick = checkedValue => {
        setToggleCheckedValue(checkedValue);
        configToggle.toggleTabOnClickHandler(checkedValue);
    };

    useEffect(() => {
        setToggleCheckedValue(configToggle.selectedValue);
    }, [configToggle.selectedValue]);

    return (
        <div className={`chart-toggle-container${configToggle.className ? ` ${configToggle.className}` : ``}`}>
            <ToggleGroup
                key={configToggle.toggleName}
                className='chart-toggle-group'
                name={configToggle.toggleName}
                role='group'
                onChange={handleToggleOnClick}
            >
                {
                    map(configToggle.toggle, (toggleDetails, tIndex) =>
                        <Toggle
                            key={`${configToggle.toggleName}-${toggleDetails.toggleValue.replace(/\s+/ig, '-').toLowerCase()}-${tIndex}`}
                            className={`chart-toggle-details${toggleDetails.className ? ` ${toggleDetails.className}` : ''}`}
                            checked={toggleDetails.toggleValue === toggleCheckedValue}
                            label={toggleDetails.toggleLabel}
                            value={toggleDetails.toggleValue}
                        />
                    )
                }
            </ToggleGroup>
        </div>
    );
};

ToggleTabs.propTypes = {
    configToggle: shape({
        toggleName: string.isRequired,
        className: string,
        toggleTabOnClickHandler: func.isRequired,
        checkedValue: string,
        toggle: arrayOf(
            shape({
                toggleLabel: string.isRequired,
                toggleValue: string.isRequired,
                className: string
            })
        ).isRequired,
    })
};

export default ToggleTabs;
